namespace ekh {

    interface MenuItem {
        name: string;
        target: string;
        offset?: number;
        value: string;
    }

    interface IGtmOptions {
        category?: string;
        action?: string;
        label?: string;
    }

    class StickyNavBar {

        selectedIndex: number = 0;
        menuToggled: boolean = false;

        title: string;
        headingType: string;
        titleHtml: string;

        currentTop: number = 0;
        previousTop: number = 0;

        isFixed: boolean = false;
        fixedYPosition: number = 0;
        yOffset: number = 0;

        elementHeight: number = 0;
        offsetValue: number = 0;
        paddingTop: number = 0;

        isAutoScrolling = false;

        menuItems: MenuItem[];

        constructor(
            private $scope: ng.IScope,
            private $element: JQuery,
            private $window: ng.IWindowService,
            private scrollService: any,
            private $interval: any ) {

            const menuElement = $('#navbarcont');
            if (menuElement) {
                this.yOffset = menuElement.height();
                this.offsetValue = menuElement.outerHeight();
            }

            $(window).on('scroll.stickynav', (() => {
                this.fix();
            }));

            this.fixedYPosition = this.$element.offset().top - this.offsetValue;

            this.paddingTop = parseInt(this.$element.next().css('paddingTop'), 10) || 0;

            this.titleHtml = `<${this.headingType}>${this.title}</${this.headingType}>`;

            $scope.$on('$destroy', () => {
                $(window).off('scroll.stickynav');
            });

        };

        selectAnchor = (index: number) => {
            this.updateSelectedIndex(index);
            if (this.menuToggled) {
                this.menuToggled = false;
            }
        }

        gotoAnchor = (anchor: string) => {
            if (this.menuItems[this.selectedIndex]) {
                const target = this.menuItems[this.selectedIndex].offset;

                let targetValue = this.yOffset + this.offsetValue + 30;

                if(!TRPCONFIG.IsMobileDevice) {
                    const signup = $('.cms-newsletter-sign-up');
                    if (signup.length > 0) {
                        targetValue += signup.outerHeight();
                    }
                }

                if (target) {
                    $('body,html').animate(
                        { scrollTop: target - ( targetValue )},
                        {
                            duration: 'slow',
                            start: () => { this.isAutoScrolling = true; },
                            done: () => { this.isAutoScrolling = false; }
                        }
                    );
                }
            }
        }

        toggle = () => {
            this.menuToggled = !this.menuToggled;
        }

        attachElements = (value) => {
            const stickyHeight = this.$element.height();
            let totalHeight = stickyHeight;
            const signup = $('.cms-newsletter-sign-up');
            if(signup.length > 0) {
                totalHeight += signup.outerHeight();
                if (value) {
                    signup.css({top: this.offsetValue + stickyHeight});
                    signup.addClass('fixed');
                } else {
                    signup.removeClass('fixed');
                }
            }
            const siblingSection = this.$element.nextAll('section');
            if(siblingSection.length > 0 && siblingSection[0].tagName === 'SECTION') {
                const elem = $(siblingSection[0]);
                elem.css({ 'paddingTop': value ? totalHeight + 'px' : '0px' });
            }
        }

        fix = () => {
            this.currentTop = this.scrollService.getScrollOffsets(this.$window).y;
            if (!this.isFixed) { this.fixedYPosition = this.$element.offset().top; }

            if (this.currentTop > this.previousTop) {
                if (this.currentTop >= this.fixedYPosition - this.offsetValue) {
                    this.$scope.$apply(() => {
                        this.isFixed = true;
                        if (!TRPCONFIG.IsMobileDevice) {this.attachElements(true);}
                    });
                }
            } else {
                if (this.currentTop <= this.fixedYPosition - this.offsetValue) {
                    this.$scope.$apply(() => {
                        this.isFixed = false;
                        if (!TRPCONFIG.IsMobileDevice) {this.attachElements(false);}
                    });
                }
            }

            const index = this.findClosestTarget();

            if (index) { this.updateSelectedIndex(index); }

            this.previousTop = this.currentTop;
        }

        findClosestTarget() {
            if (this.isAutoScrolling) { return; }
            let index = 0;
            const height = this.$element.height();
            const headings = $('h1,h2,h3,h4,h5,h6');
            for (let i = 0; i < this.menuItems.length; i++) {

                const item = this.menuItems[i];
                if (item.offset) {
                    const itemText = `:contains(${item.value})`;

                    const domItem = headings.filter(itemText).first();

                    if (domItem.length > 0) {
                        item.offset = domItem.offset().top;
                        if (this.currentTop + height > (item.offset - (this.yOffset + this.offsetValue + 30))) {
                            index = i;
                        }
                    }

                }
            }

            return index;
        }

        updateSelectedIndex(index) {
            this.selectedIndex = index;
        }
    }

    angular
        .module('ekh')
        .directive('stickyNavBar', ($document, $anchorScroll, $compile) => {
            return {
                restrict: 'E',
                replace: true,
                transclude: true,
                scope: {},
                bindToController: {
                    scrollOffsetElement: '@',
                    contentElement: '@',
                    menuOffsetElement: '@',
                    title: '@',
                    data: '@',
                    headingType: '@'
                },
                controllerAs: 'cm',
                templateUrl: 'partials/home/directivetemplate?type=StickyNavBar',
                controller: StickyNavBar,
                link(scope, element, attrs, navBarCtrl: StickyNavBar, transcludeFn) {

                    const items: any = [];

                    const cloned = transcludeFn(scope, function (elements) {
                        let count = 0;
                        angular.forEach(elements, function (item) {
                            if (item.nodeType !== 3) {
                                var text = $.trim(item.textContent);
                                items.push({ value: text });
                                const gtmOptions = getGtmOptions(item);
                                element
                                    .find('ul.sticky-navbar-menu-list')
                                    .append(createCloneElement(count, text, gtmOptions));
                                element
                                    .find('ul.sticky-navbar-touch-menu-list')
                                    .append(createCloneElement(count, text, gtmOptions));
                                count++;
                            }
                        });
                    });

                    function createCloneElement(count, text, gtmOptions: IGtmOptions = {}) {
                        let eventTrackerDirective = '';
                        if (Object.keys(gtmOptions).length) {
                            eventTrackerDirective = `
                                event-tracker
                                event-category="${gtmOptions.category}" 
                                event-action="${gtmOptions.action}" 
                                event-label="${gtmOptions.label}" 
                            `;
                        }

                        return $compile(
                            `<li ng-class="{ selected : cm.selectedIndex == ${count}}">
                                <a sticky-nav-bar-item title="${text}" 
                                    target="${text.replace(/\s/g, '').toLowerCase()}" 
                                    index="${count}"
                                    ${eventTrackerDirective}
                                    >
                                </a>
                            </li>`)(scope, undefined, {
                                transcludeControllers: {
                                    stickyNavBar: {
                                        instance: StickyNavBar
                                    }
                                }
                            });
                    }

                    var targets = document.querySelectorAll('h1,h2,h3,h4,h5,h6');

                    angular.forEach(items, function (item) {
                        var domTarget = _.filter(targets, function (target) {
                            return item.value === target.textContent;
                        });

                        if (domTarget.length) { item.offset = $(domTarget).offset().top; }
                    });

                    //for each h1 , if text matches store top value for link to click on
                    navBarCtrl.menuItems = items;

                    function getGtmOptions(element): IGtmOptions | {} {
                        element = $(element).find('[event-tracker]');

                        if (element.length) {
                            return {
                                category: element.attr('event-category'),
                                action: element.attr('event-action'),
                                label: element.attr('event-label')
                            };
                        }
                        return {};
                    }
                }
            };
        });

    class StickyNavBarItem {
        title: string;
        index: number;
        target: string;

        constructor(private $scope) {
        }

        selectAnchor = () => {
            this.$scope.$parent.cm.selectAnchor(this.index);
            this.$scope.$parent.cm.gotoAnchor(this.target);
        }
    }

    angular.module('ekh')
        .directive('stickyNavBarItem', () => {
            return {
                restrict: 'A',
                replace: true,
                require: 'stickyNavBar',
                scope: {},
                bindToController: {
                    title: '@',
                    index: '@',
                    target: '@'
                },
                controller: StickyNavBarItem,
                controllerAs: 'snbi',
                template: '<a ng-click="snbi.selectAnchor()"><span>{{ snbi.title }}</span></a>'
            };
        });
};
